// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-3b052Pj"};